{
  "version": 1,
  "asset_id": "45106dc9-4a49-46b3-bf77-5cce2d1b8c38",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/45106dc9-4a49-46b3-bf77-5cce2d1b8c38/destination-roofing-crew-citrus-county-fl-1600.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/45106dc9-4a49-46b3-bf77-5cce2d1b8c38/destination-roofing-crew-citrus-county-fl-1600.avif",
  "original_filename": "destination-roofing-crew-citrus-county-fl-1600.avif",
  "size": 91839,
  "content_type": "image/avif",
  "created_at": "2026-07-21T15:42:33Z"
}
